
/**
 * Object returned by read method
 */
export class ReadResult {
  // tslint:disable-next-line:ban-types
  private callerData: any;
  private data: any;

  // tslint:disable-next-line:ban-types
  constructor(callerData: any, data: any) {
    this.callerData = callerData;
    this.data = data;
  }

  // tslint:disable-next-line:ban-types
  get CallerData(): any {
    return this.callerData;
  }

  get Data(): any {
    return this.data;
  }
}
